import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getPatientsFile () {
   return Api().get("/patient-files");
},
  updatePatientFile (params) {
    return Api().put("/patient-files",params);
  },
  addPatientFile (params) {
    return Api().post("/patient-files",params);
  },
  getPatientFile (params) {
    return Api().get("/patient-files/"+params);
  },
  getPatientFileByRouteSheets (params) {
    return Api().get("/patient-files-by-route-sheet/"+params);
  },

  deletePatientFile (params) {
    return Api().delete("/patient-files/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/PatientFileService.js